import { ApiError } from '@/lib/errors';

interface ErrorStateProps {
  title: string;
  error: unknown;
  onRetry?: () => void;
}

/**
 * One place to render a failed request. Says what failed and what to do next,
 * rather than dumping an exception.
 */
export function ErrorState({ title, error, onRetry }: ErrorStateProps) {
  const message =
    error instanceof ApiError
      ? error.userMessage
      : 'Something went wrong. Please try again.';

  return (
    <div className="mx-auto flex max-w-md flex-col items-center gap-4 px-6 py-16 text-center">
      <h2 className="text-lg font-semibold text-content">{title}</h2>
      <p className="text-content-secondary">{message}</p>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="rounded-md bg-primary px-4 py-2 font-medium text-white hover:bg-primary-shade focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-focus"
        >
          Try again
        </button>
      )}
    </div>
  );
}
